import React from 'react';
import { Plus, X } from 'lucide-react';

interface ReminderSelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export default function ReminderSelector({ value, onChange }: ReminderSelectorProps) {
  const addReminder = () => {
    onChange([...value, '30']);
  };

  const removeReminder = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const updateReminder = (index: number, minutes: string) => {
    const newReminders = [...value];
    newReminders[index] = minutes;
    onChange(newReminders);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Lembretes
      </label>
      <div className="space-y-2">
        {value.map((minutes, index) => (
          <div key={index} className="flex items-center space-x-2">
            <select
              value={minutes}
              onChange={(e) => updateReminder(index, e.target.value)}
              className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500"
            >
              <option value="5">5 minutos antes</option>
              <option value="15">15 minutos antes</option>
              <option value="30">30 minutos antes</option>
              <option value="60">1 hora antes</option>
              <option value="1440">1 dia antes</option>
            </select>
            <button
              type="button"
              onClick={() => removeReminder(index)}
              className="p-2 text-gray-500 hover:text-red-500"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addReminder}
          className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700"
        >
          <Plus className="h-5 w-5" />
          <span>Adicionar lembrete</span>
        </button>
      </div>
    </div>
  );
}